module.exports = {

	methods: {
		clearPictureWall: function() {
			
			var self = this;

			// Prompt to save if needed first
	    	self.promtSave(function(){

				// Tell that no current wall is selected and not updated
				try{
					window.eventHub.$emit('closePickers', 'all');
					self.$store.commit('currentWallID', false)
					self.$store.commit('disablePictureWall', true)
					self.$store.commit('pictureWall', 0)
					self.$store.commit('background', false)
					self.$store.commit('pictureWallColor', {
						key: "white",
						preview: "white",
						border: "1"
					})
					self.$store.commit('currentWallField', false)
					self.$store.commit('articleFilterActive', false)
					self.$store.commit('articleFilter', false)
					self.$store.commit('articleFilterAvailable', false)
					self.$store.commit('chosenArticleFilter', false)
					self.$store.commit('chosenArticles', {})
	        		self.$store.commit('chosenFrames', {})
	        		self.$store.commit('updated', false)
	        		self.$store.commit('disablePictureWall', false)

					console.log("Disable?")

				}catch(e){
					console.log(e)
				}
	        });
			
		}
	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/clear.js